module.exports = __webpack_public_path__ + "img/126.e2c76ecf.jpg";